<template>
  <div class="video" @mouseenter="mouseEnter" @mouseleave="mouseLeave"
       :style="{backgroundColor:shouldBeBlack?'#000':'#fff'}">
    <img src="https://summit-img.geekpark.net/03-%E8%A7%86%E9%A2%91-This%20is%20IF.svg"
         style="width: 120vh;margin: 4vh auto;" v-if="shouldBeBlack">
    <img
      src="https://summit-img.geekpark.net/03-%E8%A7%86%E9%A2%91-This%20is%20IF-%E7%99%BD%E5%BA%95%E9%BB%91%E5%AD%97.svg"
      style="width: 120vh;margin: 4vh auto;" v-else>
    <div class="video-container">
      <div class="cover" @click="playVideo" v-show="!videoStarted">
        <img src="https://summit-img.geekpark.net/03-%E8%A7%86%E9%A2%91-%E6%92%AD%E6%94%BE%E6%8C%89%E9%92%AE.svg"
             alt="">
      </div>
      <video style="width:125vh" ref="video" poster="https://summit-img.geekpark.net/video-bg.jpg"
             controlslist="nodownload noremoteplayback"
             :controls="videoStarted">
        <source type="video/mp4" src="https://summit-img.geekpark.net/video/%E5%A4%A7%E4%BC%9A%E8%8A%B1%E7%B5%AE.MP4">
      </video>
    </div>
    <img src="https://summit-img.geekpark.net/03-%E8%A7%86%E9%A2%91-GEEKPARK%20INNOVATION.svg"
         style="width: 80vh;margin-top: 3.4vh;">
  </div>
</template>

<script>

export default {
  name: 'Video',
  data () {
    return {
      isInVideoBox: false,
      videoStarted: false,
      isPlaying: false
    }
  },
  computed: {
    shouldBeBlack () {
      return this.isPlaying || this.isInVideoBox
    }
  },
  mounted () {
    const video = this.$refs.video
    video.disablePictureInPicture = true
    video.addEventListener('pause', () => {
      this.isPlaying = false
      console.log('暫停')
    }, false)
    video.addEventListener('play', () => {
      this.isPlaying = true
      console.log('播放')
    }, false)
  },
  methods: {
    playVideo () {
      this.$refs.video.play()
      this.videoStarted = true
      this.isPlaying = true
    },
    mouseEnter () {
      this.isInVideoBox = true
    },
    mouseLeave () {
      this.isInVideoBox = false
    }
  }
}
</script>

<style scoped lang="less">
  .video {
    height: 100%;
    margin-left: 15vh;
    padding: 0 15vh;
    transition: background-color .3s;
  }

  .video-container {
    position: relative;
    overflow: hidden;

    &:hover {
      cursor: pointer;
    }

    .cover {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 10;

      img {
        width: 12vh;
        height: 12vh;
      }
    }
  }

  video:focus {
    border: none;
    outline: none;
  }
</style>
